<template>

    <loading v-if="fetchingUsers" size="small"/>
    <user-avatars :users="users.reverse()" size="small" :max="5" v-else/>

</template>

<script>
import {mapState} from 'pinia';
import {useRepo} from "pinia-orm";
import {useAuthenticationStore} from '../../state/modules/authentication';
import Application from '../../models/Application';
import Job from '../../models/Job';
import User from '../../models/User';
import Loading from './Loading.vue';
import { uniq as _uniq } from 'lodash'
import Tooltip from "../navigation/Tooltip";
import UserAvatars from "./UserAvatars";

export default {
    components: {
        UserAvatars,
        Tooltip,
        'loading': Loading,
    },
    props: {
        target: {
            required: false,
            validator: value => value instanceof Application || value instanceof Job,
        },
    },
    data() {
        return {
            access: null
        }
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentCompanyId']),
        fetchingUsers() {
            return User.fetching;
        },
        permissionPrefix() {
            if (this.target instanceof Application)
                return "applications";
            if (this.target instanceof Job)
                return "jobs";
        },
        users() {
            if (this.permissionPrefix === 'applications') {
                return useRepo(User)
                    .whereHas('companies', query => query.whereId(this.currentCompanyId))
                    .get()
                    .map(user => {
                        const perms = user.permissions[this.currentCompanyId];
                        user.can = {};

                        if (!perms)
                            return user;

                        if (perms.includes(this.permissionPrefix + '.manage'))
                            user.can.manage = true;
                        if (perms.includes(this.permissionPrefix + '.view'))
                            user.can.view = true;
                        if (perms.includes(this.permissionPrefix + '.manage.' + this.target.id))
                            user.can.manage_this = true;
                        if (perms.includes(this.permissionPrefix + '.view.' + this.target.id))
                            user.can.view_this = true;

                        if (this.target.stage?.job) {
                            const jobId = this.target.stage.job.id;

                            if (perms.includes('job-applications.manage.' + jobId))
                                user.can.manage_job = true;
                            if (perms.includes('job-applications.view.' + jobId))
                                user.can.view_job = true;
                        }

                        user.permLevel = 0;
                        if (user.can.manage || user.can.manage_this || user.can.manage_job)
                            user.permLevel = 2;
                        else if (user.can.view || user.can.view_this || user.can.view_job)
                            user.permLevel = 1;

                        return user;
                    })
                    .filter(user => user.permLevel >= 1)
                    .sort((a, b) => b.permLevel - a.permLevel);
            } else {
                return useRepo(User).where('id', this.target.responsible_user_id).get();
            }
        }
    },
    mounted () {
        User.fetchUsers();
    }
}
</script>
